import * as angular from "angular";
import { House } from "../../models/house.model";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewHouseComponent = {
    selector: "vcViewHouse",
    templateUrl: "/angular/components/house/view-house.component.html",
    bindings: {
        selectedHouse: "=?",
        selectedHid: "=?",
    },
    controller: class ViewHouseController {
        // * bindings for typescript compiler *
        public selectedHouse?: any;
        public selectedHid?: any;
        // ************************************

        public hid: string;
        public house: House;
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.hid = this.selectedHid ? this.selectedHid : null;
            this.house = this.selectedHouse ? this.selectedHouse : null;
        }

        close(house: House): void {
            if (angular.isDefined(house)) {
                this.dialog.hide(house);
            } else {
                this.dialog.cancel();
            }
        }
    },
};

angular
    .module("house")
    .component(ViewHouseComponent.selector, ViewHouseComponent);
